export const cusRoutes = [
  {
    path: "/girds",
    meta: {
      title: "网格管理",
    },
    component: () => import("@/cusPages/girds"),
  },
  {
    path: "/girdMember",
    meta: {
      title: "网格员管理",
    },
    component: () => import("@/cusPages/girds/girdMember.vue"),
  },
  {
    path: "/device",
    meta: {
      title: "设备列表",
    },
    component: () => import("@/cusPages/device"),
  },
  {
    path: "/device/classify",
    meta: {
      title: "设备分类",
    },
    component: () => import("@/cusPages/device/classify.vue"),
  },
  {
    path: "/signIn",
    meta: {
      title: "签到管理",
    },
    component: () => import("@/cusPages/signIn"),
  },
  {
    path: "/face",
    meta: {
      title: "人脸识别",
    },
    component: () => import("@/cusPages/face"),
  },
  {
    path: "/security",
    meta: {
      title: "安保组管理",
    },
    component: () => import("@/cusPages/security"),
  },
  {
    path: "/broadcast",
    meta: {
      title: "广播列表",
    },
    component: () => import("@/cusPages/broadcast"),
  },
  {
    path: "/broadcastMedia",
    meta: {
      title: "广播节目库",
    },
    component: () => import("@/cusPages/broadcastMedia"),
  },
  {
    path: "/data-analysis",
    meta: {
      title: "数据分析",
    },
    component: () => import("@/cusPages/data-analysis"),
  },
  {
    path: "/count-performance",
    meta: {
      title: "绩效统计",
    },
    component: () => import("@/cusPages/performance"),
  },
  {
    path: "/routeManage",
    meta: {
      title: "巡更路线",
    },
    component: () => import("@/cusPages/routePatrol/routeManage.vue"),
  },
  {
    path: "/routePoint",
    meta: {
      title: "巡检点管理",
    },
    component: () => import("@/cusPages/routePatrol/routePoint.vue"),
  },
  {
    path: "/routePlan",
    meta: {
      title: "巡更任务",
    },
    component: () => import("@/cusPages/routePatrol/patrolPlan.vue"),
  },
  {
    path: "/routeRecord",
    meta: {
      title: "巡更记录",
    },
    component: () => import("@/cusPages/routePatrol/patrolRecord.vue"),
  },
  {
    path: "/routeManageCard",
    meta: {
      title: "巡更路线",
    },
    component: () => import("@/cusPages/routePatrolCard/routeManage.vue"),
  },
  {
    path: "/routePointCard",
    meta: {
      title: "巡检点管理",
    },
    component: () => import("@/cusPages/routePatrolCard/routePoint.vue"),
  },
  {
    path: "/routePlanCard",
    meta: {
      title: "巡更任务",
    },
    component: () => import("@/cusPages/routePatrolCard/patrolPlan.vue"),
  },
  {
    path: "/routeRecordCard",
    meta: {
      title: "巡更记录",
    },
    component: () => import("@/cusPages/routePatrolCard/patrolRecord.vue"),
  },
  {
    path: "/route-warning",
    meta: {
      title: "巡查异常警告",
    },
    component: () => import("@/cusPages/routePatrolCard/routeWarning.vue"),
  },
  {
    path: "/girdMember",
    meta: {
      title: "网格员管理",
    },
    component: () => import("@/cusPages/girds/girdMember.vue"),
  },
  {
    path: "/securityMember",
    meta: {
      title: "维护人员管理",
    },
    component: () => import("@/cusPages/security/securityMember.vue"),
  },
  {
    path: "/help-center",
    meta: {
      title: "帮助中心",
    },
    component: () => import("@/cusPages/help/index.vue"),
  },
  {
    path: "/town",
    meta: {
      title: "分管组管理",
    },
    component: () => import("@/cusPages/town/index.vue"),
  },
  {
    path: "/message",
    meta: {
      title: "短信通知",
    },
    component: () => import("@/cusPages/message/index.vue"),
  },
  {
    path: "/message-list",
    meta: {
      title: "短信列表",
    },
    component: () => import("@/cusPages/message/list.vue"),
  },
  {
    path: "/town-member",
    meta: {
      title: "分管员管理",
    },
    component: () => import("@/cusPages/town/townMember.vue"),
  },
  {
    path: "/monitoring",
    meta: {
      title: "智能监控",
    },
    component: () => import("@/cusPages/monitoring"),
  },
  {
    path: "/device/group",
    meta: {
      title: "设备分组",
    },
    component: () => import("@/cusPages/device/deviceGroup"),
  },
  {
    path: "/area-manage",
    meta: {
      title: "小区管理",
    },
    component: () => import("@/cusPages/person-car-center/area-manage"),
  },
  {
    path: "/room-manage",
    meta: {
      title: "房屋管理",
    },
    component: () => import("@/cusPages/person-car-center/room-manage"),
  },
  {
    path: "/owner-manage",
    meta: {
      title: "业主信息",
    },
    component: () => import("@/cusPages/person-car-center/owner-manage"),
  },
  {
    path: "/owner-member-manage",
    meta: {
      title: "业主成员管理",
    },
    component: () => import("@/cusPages/person-car-center/owner-member-manage"),
  },
  {
    path: "/expense-type",
    meta: {
      title: "费用项设置",
    },
    component: () => import("@/cusPages/payment/expenseType.vue"),
  },
  {
    path: "/pay-check-refund",
    meta: {
      title: "缴费退款审核",
    },
    component: () => import("@/cusPages/payment/payCheckRefund.vue"),
  },
  {
    path: "/pay-check-refund-park",
    meta: {
      title: "缴费退款审核",
    },
    component: () => import("@/cusPages/payment/payCheckRefundPark.vue"),
  },
  {
    path: "/pay-question",
    meta: {
      title: "缴费问答",
    },
    component: () => import("@/cusPages/payment/payQuestion.vue"),
  },
  {
    path: "/room-charge",
    meta: {
      title: "房屋收费",
    },
    component: () => import("@/cusPages/payment/roomCharge.vue"),
  },
  {
    path: "/cash-charge",
    meta: {
      title: "保证金收费",
    },
    component: () => import("@/cusPages/payment/cashCharge.vue"),
  },
  {
    path: "/main-device-manage",
    meta: {
      title: "维护设备管理",
    },
    component: () => import("@/cusPages/mainDevice/manage.vue"),
  },
  {
    path: "/main-device-group",
    meta: {
      title: "维护设备分组",
    },
    component: () => import("@/cusPages/mainDevice/group.vue"),
  },
  {
    path: "/main-device-log",
    meta: {
      title: "维护设备日志",
    },
    component: () => import("@/cusPages/mainDevice/log.vue"),
  },
  {
    path: "/main-device-task",
    meta: {
      title: "维护设备巡检任务",
    },
    component: () => import("@/cusPages/mainDevice/task.vue"),
  },
  {
    path: "/main-device-plan",
    meta: {
      title: "维护设备巡检计划",
    },
    component: () => import("@/cusPages/mainDevice/plan.vue"),
  },

  // 资产管理
  {
    path: "/money-base-category",
    meta: {
      title: "资产类别列表",
    },
    component: () => import("@/cusPages/assets/category.vue"),
  },
  // 资产管理
  {
    path: "/money-enter-assets",
    meta: {
      title: "入库单列表",
    },
    component: () => import("@/cusPages/assets/enter.vue"),
  },

  // 资产信息
  {
    path: "/money-daily-info",
    meta: {
      title: "资产信息",
    },
    component: () => import("@/cusPages/assets/info.vue"),
  },
  {
    path: "/money-daily-borrow",
    name: "moneyDailyBorrow",
    component: () => import("@/cusPages/assets/borrow.vue"),
    meta: {
      title: "资产领用列表",
    },
  },
  {
    path: "/money-daily-return",
    name: "moneyDailyReturn",
    component: () => import("@/cusPages/assets/return.vue"),
    meta: {
      title: "资产退还列表",
    },
  },
  {
    path: "/money-daily-employed",
    name: "moneyDailyEmployed",
    component: () => import("@/cusPages/assets/employed.vue"),
    meta: {
      title: "资产退还列表",
    },
  },
  // 资产盘点
  {
    path: "/money-inventory-rule",
    name: "moneyInventoryRule",
    component: () => import("@/cusPages/assets/rule.vue"),
    meta: {
      title: "盘点规则",
    },
  },
  {
    path: "/money-inventory-program",
    name: "moneyInventoryProgram",
    component: () => import("@/cusPages/assets/program.vue"),
    meta: {
      title: "盘点方案",
    },
  },
  {
    path: "/money-inventory-administrative",
    name: "moneyInventoryAdministrative",
    component: () => import("@/cusPages/assets/administrative.vue"),
    meta: {
      title: "行政盘点",
    },
  },
  {
    path: "/money-inventory-result",
    name: "moneyInventoryResult",
    component: () => import("@/cusPages/assets/result.vue"),
    meta: {
      title: "财务结果",
    },
  },
  // 资产处置
  {
    path: "/money-deal-index",
    name: "moneyDealIndex",
    component: () => import("@/cusPages/assets/deal.vue"),
    meta: {
      title: "资产处置",
    },
  },
  /* 社区模块 */
  // 社区活动管理
  {
    path: "/community-activity-manage",
    component: () => import("@/cusPages/community/activityManage"),
  },
  // 社区活动报名审核
  {
    path: "/community-activity-check",
    component: () => import("@/cusPages/community/activityCheck"),
  },
  // 志愿者管理
  {
    path: "/volunteer-manage",
    component: () => import("@/cusPages/community/volunteerManage"),
  },
  // 社区话题审核
  {
    path: "/community-topic-check",
    component: () => import("@/cusPages/community/topicCheck"),
  },
  // 社区话题类别管理
  {
    path: "/community-topic-typeManage",
    component: () => import("@/cusPages/community/topicTypeManage"),
  },
  // 志愿者审核
  {
    path: "/community-volunteer-check",
    component: () => import("@/cusPages/community/volunteerCheck"),
  },
  // 老年人服务 老人信息
  {
    path: "/old-person-list",
    component: () => import("@/cusPages/oldPerson/list"),
  },
  // 老年人服务 老人事件
  {
    path: "/old-person-event",
    component: () => import("@/cusPages/oldPerson/event"),
  },
  // 公告管理
  {
    path: "/notice",
    component: () => import("@/cusPages/notice"),
  },
  // 对外停车场管理
  {
    path: "/out-park-manage",
    component: () => import("@/cusPages/person-car-center/out-park/manage"),
  },
  // 对外停车场包月
  {
    path: "/out-park-month",
    component: () => import("@/cusPages/person-car-center/out-park/month"),
  },
  // 小区停车场管理
  {
    path: "/in-park-manage",
    component: () => import("@/cusPages/person-car-center/in-park/manage"),
  },
  // 工牌管理
  {
    path: "/workCard-manage",
    component: () => import("@/cusPages/workCard"),
  },
  // 实时定位
  {
    path: "/real-view",
    component: () => import("@/cusPages/realView"),
  },

  {
    path: "/goods-base-group",
    name: "goodsBaseGroup",
    component: () => import("@/cusPages/goods/base/group.vue"),
    meta: {
      title: "物品分组设置",
    },
  },
  {
    path: "/goods-base-set",
    name: "goodsBaseSet",
    component: () => import("@/cusPages/goods/base/goods.vue"),
    meta: {
      title: "物品设置",
    },
  },
  {
    path: "/goods-base-house",
    name: "thingBaseHouse",
    component: () => import("@/cusPages/goods/base/house.vue"),
    meta: {
      title: "仓库设置",
    },
  },
  {
    path: "/goods-base-unit",
    name: "goodsBaseUnit",
    component: () => import("@/cusPages/goods/base/unit.vue"),
    meta: {
      title: "计量单位设置",
    },
  },

  // 库房管理
  {
    path: "/goods-store-enter",
    name: "goodsStoreEnter",
    component: () => import("@/cusPages/goods/store/enter.vue"),
    meta: {
      title: "物品入库列表",
    },
  },
  {
    path: "/goods-store-receive",
    name: "goodsStoreUseList",
    component: () => import("@/cusPages/goods/store/receive.vue"),
    meta: {
      title: "物品领用列表",
    },
  },
  {
    path: "/goods-store-deal",
    name: "goodsStoreDeal",
    component: () => import("@/cusPages/goods/store/deal.vue"),
    meta: {
      title: "物品处置列表",
    },
  },
  {
    path: "/goods-store-apply",
    name: "goodsStoreApply",
    component: () => import("@/cusPages/goods/store/apply.vue"),
    meta: {
      title: "物品采购申请",
    },
  },
  {
    path: "/goods-store-allot",
    name: "goodsStoreAllot",
    component: () => import("@/cusPages/goods/store/allot.vue"),
    meta: {
      title: "物品调拨列表",
    },
  },
  {
    path: "/goods-store-check",
    name: "goodsStoreCheck",
    component: () => import("@/cusPages/goods/store/check.vue"),
    meta: {
      title: "物品判断列表",
    },
  },
  // 报表查询
  {
    path: "/goods-report-scan",
    name: "goodsReportScan",
    component: () => import("@/cusPages/goods/report/scan.vue"),
    meta: {
      title: "库存浏览表",
    },
  },
  {
    path: "/goods-report-despatcher",
    name: "goodsReportDespatcher",
    component: () => import("@/cusPages/goods/report/despatcher.vue"),
    meta: {
      title: "收发明细表",
    },
  },
  {
    path: "/goods-report-division",
    name: "goodsReportDivision",
    component: () => import("@/cusPages/goods/report/division.vue"),
    meta: {
      title: "部门领用表",
    },
  },
  {
    path: "/goods-report-monthly",
    name: "goodsReportMonthly",
    component: () => import("@/cusPages/goods/report/monthly.vue"),
    meta: {
      title: "月度结转表",
    },
  },
  // 采购管理
  {
    path: "/purchaseManagement-apply",
    meta: {
      title: "采购申请",
    },
    component: () => import("@/cusPages/purchaseManagement/apply.vue"),
  },
  {
    path: "/purchaseManagement-order",
    meta: {
      title: "采购订单",
    },
    component: () => import("@/cusPages/purchaseManagement/orders.vue"),
  },
  //   // 资产管理
  //   {
  //     path: "/money-base-category",
  //     meta: {
  //       title: "资产类别列表",
  //     },
  //     component: () => import("@/cusPages/assets/category.vue"),
  //   },
  //   // 资产管理
  //   {
  //     path: "/money-enter-assets",
  //     meta: {
  //       title: "入库单列表",
  //     },
  //     component: () => import("@/cusPages/assets/enter.vue"),
  //   },
  //   // 资产信息
  //   {
  //     path: "/money-daily-info",
  //     meta: {
  //       title: "资产信息",
  //     },
  //     component: () => import("@/cusPages/assets/info.vue"),
  //   },
  //   {
  //     path: "/money-daily-borrow",
  //     name: "moneyDailyBorrow",
  //     component: () => import("@/cusPages/assets/borrow.vue"),
  //     meta: {
  //       title: "资产领用列表",
  //     },
  //   },
  //   {
  //     path: "/money-daily-return",
  //     name: "moneyDailyReturn",
  //     component: () => import("@/cusPages/assets/return.vue"),
  //     meta: {
  //       title: "资产退还列表",
  //     },
  //   },
  //   {
  //     path: "/money-daily-employed",
  //     name: "moneyDailyEmployed",
  //     component: () => import("@/cusPages/assets/employed.vue"),
  //     meta: {
  //       title: "资产退还列表",
  //     },
  //   },
  //   // 资产盘点
  //   {
  //     path: "/money-inventory-rule",
  //     name: "moneyInventoryRule",
  //     component: () => import("@/cusPages/assets/rule.vue"),
  //     meta: {
  //       title: "盘点规则",
  //     },
  //   },
  //   {
  //     path: "/money-inventory-program",
  //     name: "moneyInventoryProgram",
  //     component: () => import("@/cusPages/assets/program.vue"),
  //     meta: {
  //       title: "盘点方案",
  //     },
  //   },
  //   {
  //     path: "/money-inventory-administrative",
  //     name: "moneyInventoryAdministrative",
  //     component: () => import("@/cusPages/assets/administrative.vue"),
  //     meta: {
  //       title: "行政盘点",
  //     },
  //   },
  //   {
  //     path: "/money-inventory-result",
  //     name: "moneyInventoryResult",
  //     component: () => import("@/cusPages/assets/result.vue"),
  //     meta: {
  //       title: "财务结果",
  //     },
  //   },
  //   // 资产处置
  //   {
  //     path: "/money-deal-index",
  //     name: "moneyDealIndex",
  //     component: () => import("@/cusPages/assets/deal.vue"),
  //     meta: {
  //       title: "资产处置",
  //     },
  //   },
];
